export default "__VITE_ASSET__BHZN2TDE__"